import React from 'react';
import {
    ComposedChart,
    Line,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from 'recharts';
import styles from './styles.module.css';
import './styles.css';
import { useTranslation } from '../../i18n';

interface MatchScoreChartProps {
    familyScore: number;
    familyBaselineRange: [number, number];
    adhocracyScore: number;
    adhocracyBaselineRange: [number, number];
    marketScore: number;
    marketBaselineRange: [number, number];
    hierarchyScore: number;
    hierarchyBaselineRange: [number, number];
    isWeb: boolean;
}

const WorkPreferenceAreaChart = (props: MatchScoreChartProps) => {
    const {
        familyScore,
        familyBaselineRange,
        adhocracyScore,
        adhocracyBaselineRange,
        marketScore,
        marketBaselineRange,
        hierarchyScore,
        hierarchyBaselineRange,
        isWeb
    } = props;
    const { t } = useTranslation();

    const data = [
        {
            name: t(`CULTURAL_FIT.WORK_PREFERENCES.CATEGORIES.FAMILY`),
            score: familyScore,
            baseline: familyBaselineRange,
        },
        {
            name: t(`CULTURAL_FIT.WORK_PREFERENCES.CATEGORIES.ADHOCRACY`),
            score: adhocracyScore,
            baseline: adhocracyBaselineRange,
        },
        {
            name: t(`CULTURAL_FIT.WORK_PREFERENCES.CATEGORIES.MARKET`),
            score: marketScore,
            baseline: marketBaselineRange,
        },
        {
            name: t(`CULTURAL_FIT.WORK_PREFERENCES.CATEGORIES.HIERARCHY`),
            score: hierarchyScore,
            baseline: hierarchyBaselineRange,
        },
    ];

    const maxScore = Math.max(...data.map((cat) => cat.score));
    const maxBaseline = Math.max(...data.map((cat) => cat.baseline[1]));
    const yAxisDataKey = maxScore > maxBaseline ? 'score' : 'baseline';

    return (
        <div className="workPreferencesAreaChart">
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={data}>
                    <CartesianGrid stroke="#40596F53" vertical={false} />
                    <Tooltip wrapperStyle={{ outlineWidth: '0', fontSize:14 }} />
                    <Area
                        dataKey="baseline"
                        fill="#D6EDFF"
                        fillOpacity={1}
                        stroke="#D6EDFF"
                        type="linear"
                        activeDot={false}
                        isAnimationActive={isWeb}
                        fontSize={14}
                    />
                    <Line
                        dataKey="score"
                        stroke="#00A5AC"
                        strokeWidth={3}
                        fill="#00A5AC"
                        dot={{ r: 6 }}
                        fontSize={14}
                        isAnimationActive={isWeb}
                    />
                    <Legend
                        layout="horizontal"
                        verticalAlign="top"
                        align="right"
                        fontSize={14}
                        content={() => (
                            <div className={styles.legendWrap}>
                                <span>
                                    {t(
                                        'CULTURAL_FIT.WORK_PREFERENCES.SHADED_CHART.LEGEND_CANDIDATE_SCORE',
                                    )}
                                </span>
                                <span>
                                    {t(
                                        'CULTURAL_FIT.WORK_PREFERENCES.SHADED_CHART.LEGEND_COMPANY_RANGE',
                                    )}
                                </span>
                            </div>
                        )}
                    />
                    <XAxis
                        dataKey="name"
                        type="category"
                        padding={{ left: 40, right: 40 }}
                        tickLine={false}
                        fontSize={14}
                    />
                    <YAxis
                        dataKey={yAxisDataKey}
                        type="number"
                        scale="auto"
                        axisLine={false}
                        tickLine={false}
                        fontSize={14}
                    />
                </ComposedChart>
            </ResponsiveContainer>
        </div>
    );
};

export default WorkPreferenceAreaChart;
